<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Comprometimento"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <projeto-acao-form
            operacaoProp="A"
            :comprometimento="comprometimento"
            :convenio="convenio"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></projeto-acao-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import ProjetoAcaoForm from './ProjetoAcaoForm.vue'

export default {
    components:{
        ProjetoAcaoForm,
    },

    props: {
        convenio: Object,
        comprometimento: Object, 
    },

    data(){
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(comprometimento){
            this.$store.dispatch('addRequest')
            let comprometimentoDto = {
                idConvenio : this.convenio.idConvenio,
                idRateioComprometimento: comprometimento.idRateioComprometimento,
                idCronogramaDesembolso:comprometimento.idCronogramaDesembolso,
                nuValorRateio:comprometimento.nuValorRateio,
                codCCusto: comprometimento.codCCusto,
                nomeCCusto: comprometimento.nomeCCusto
            }
            ConveniosServicos.AlterarRateioComprometimento(comprometimentoDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Comprometimento atualizado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarListaComprometimentos')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    },
}

</script>